import React, { useState, useContext } from "react";
import { sizeLimit, useLocation } from "@app/utils";
import { Icon } from "@app/components";
import { uploadImage } from "@app/services";
import { AuthContext } from "@app/providers";
import {
  ProfileImage,
  ProgressBar,
  ProgreeBarInnner,
  SingleImage,
  AddProfileDiv,
  AddProfileText,
  AddProfileInput,
  ImageInstructions,
  ProfileImageWrapper,
} from "./image-uploader-components";

type Props = {
  userName?: string;
  background?: string;
  onUpdateImage: (e: any) => void;
  name: string;
  register?: any;
  onUpdateImageData: (e: any) => void;
  setImageError: (e: any) => void;
  imageError: boolean;
};
export default function ProfileUploader({
  background,
  onUpdateImage,
  name,
  register,
  onUpdateImageData,
  setImageError,
  imageError,
}: Props) {
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const [limitError, setLimitError] = useState<boolean>(false);
  const [typeError, setTypeError] = useState<boolean>(false);
  const [progress, uploadProgress] = useState(0);
  const { navigate } = useLocation();

  function onChange(e: any) {
    if (
      ["image/jpeg", "image/png", "image/jpg"].indexOf(e.target.files[0].type) <
      0
    ) {
      setImageError(true);
      setTypeError(true);
      return false;
    } else if (e.target.files[0].size > sizeLimit) {
      setTypeError(false);
      setImageError(true);
      setLimitError(true);
      return false;
    } else {
      setTypeError(false);
      setImageError(false);
      setLimitError(false);
    }
    let reader = new FileReader();
    reader.addEventListener("loadstart", () => uploadProgress(15));
    reader.addEventListener("progress", () => uploadProgress(30));
    reader.addEventListener("load", () => uploadProgress(50));
    reader.addEventListener("loadend", () => uploadProgress(65));
    reader.readAsDataURL(e.target.files[0]);
    const params: any = new FormData();
    params.append("userId", userInfo.userJson.userId);
    params.append("sessionToken", userInfo.sessionToken);
    params.append("imageType", "profiles");
    params.append("files[]", e.target.files[0]);
    uploadImage(params).then((response: any) => {
      if (response._responseStatus === 1) {
        uploadProgress(100);
        setTimeout(() => {
          uploadProgress(0);
        }, 100);
        onUpdateImage(response.thumbnailAsset);
        onUpdateImageData(response);
      } else {
        if (response.msgCode === "SSN_002") {
          localStorage.clear();
          setUserInfo(null);
          navigate("/sign-in");
        }
      }
    });
  }
  return (
    <ProfileImageWrapper>
      <ProfileImage setError={imageError}>
        <SingleImage background={background}>
          {background ? "" : <Icon name="user" />}
        </SingleImage>
        <AddProfileDiv>
          <AddProfileText>
            {background ? "Change" : "Add Picture"}
          </AddProfileText>
          <AddProfileInput
            type="file"
            accept="image/png, image/jpg, image/jpeg"
            onChange={onChange}
            name={name}
            ref={register}
          ></AddProfileInput>
        </AddProfileDiv>
        <ProgressBar>
          <ProgreeBarInnner style={{ width: progress + "%" }} />
        </ProgressBar>
      </ProfileImage>
      <ImageInstructions>
        {imageError && typeError && (
          <span>Valid file formats are JPG, JPEG, PNG</span>
        )}
        {imageError && limitError && <span>Max size allowed is 1 MB</span>}
      </ImageInstructions>
    </ProfileImageWrapper>
  );
}
